import { EventEmitter, Injectable } from '@angular/core';
import { ElectronService } from 'ngx-electron';

import { INITIAL_SPORT_TYPE_ENUM, INITIAL_TOURNAMENT_TYPE } from '~/constant/ui.constant';
import { lg } from '~/modules/colorLog';

declare let $;
declare let _sendChromeMessage: any;

interface terminalConfigData {
    IsBetOn: boolean;
    IsCashout: boolean;
    IsLiveOn: boolean;
    IsJacktimeActive: boolean;
    IsSportOn: boolean;
    ShowCashoutButton: boolean;
    TemporaryBet: boolean;
    TerminalCongId: number;
    TerminalId: number;
    IsPINActive: boolean;
}

@Injectable()
export class uiHelper {
    public buttonIsActive = true;

    public isOnlyDeposit = false;

    public oddType_PRE_Listener: EventEmitter<any> = new EventEmitter();
    public oddType_PRE: string[] = ['RoM', 'OU', 'NG'];
    public oddType_LIVE_Listener: EventEmitter<any> = new EventEmitter();
    public oddType_LIVE: string[] = ['RoM', 'OU', 'NG'];

    public sportEnum_Listener: EventEmitter<any> = new EventEmitter();
    public sportEnum: number = INITIAL_SPORT_TYPE_ENUM;

    public tournamentType_Listener: EventEmitter<any> = new EventEmitter();
    public tournamentType: number = INITIAL_TOURNAMENT_TYPE;

    public uniquetournament_Listener: EventEmitter<any> = new EventEmitter();
    public uniquetournament: number;

    public typeOfListListener: EventEmitter<any> = new EventEmitter();
    public typeOfList: string;

    public statisticListener: EventEmitter<any> = new EventEmitter();
    public liveTrackerListener: EventEmitter<any> = new EventEmitter();

    public expandIdListener: EventEmitter<any> = new EventEmitter();
    public expandId: number;

    public getSportFixtureListener: EventEmitter<any> = new EventEmitter();
    public changeSportFixture: EventEmitter<any> = new EventEmitter();
    public changeSportFixtureSort: EventEmitter<any> = new EventEmitter();

    public scoreBoxViewListener: EventEmitter<any> = new EventEmitter();
    public scoreBoxView = false;

    public liveFilteredDataListener: EventEmitter<any> = new EventEmitter();
    public liveFilteredData;

    public isDateTodayListener: EventEmitter<any> = new EventEmitter();
    public isDateToday;

    public isAdminScreenVisibleListener: EventEmitter<any> = new EventEmitter();
    public isAdminScreenVisible = false;
    public adminScreenState = 0;

    public refreshAppListener: EventEmitter<any> = new EventEmitter();

    public liveScrollChange: EventEmitter<any> = new EventEmitter();
    public preScrollChange: EventEmitter<any> = new EventEmitter();

    public SecondScreenIsActive = false;

    public qrCodeListener: EventEmitter<any> = new EventEmitter();
    public customerQrStatusListener: EventEmitter<any> = new EventEmitter();
    public customerQrStatus = false;

    public CustomerCardSatus = false;
    public customerCardStatusListener: EventEmitter<any> = new EventEmitter();

    public liveGoalList;
    public liveGoalListListener: EventEmitter<any> = new EventEmitter();

    public liveTrackerModalCloseListener: EventEmitter<any> = new EventEmitter();

    public idleResetListener: EventEmitter<any> = new EventEmitter();

    public transactionModalListener: EventEmitter<any> = new EventEmitter();

    public slipDuplicateModalListener: EventEmitter<any> = new EventEmitter();

    public terminalConfig: terminalConfigData = {
        IsBetOn: false,
        IsCashout: false,
        IsLiveOn: false,
        IsSportOn: false,
        IsJacktimeActive: false,
        ShowCashoutButton: false,
        TemporaryBet: false,
        TerminalCongId: 1,
        TerminalId: 0,
        IsPINActive: true,
    };
    public terminalConfigListener: EventEmitter<any> = new EventEmitter();

    public barcodeCardModalEventListener: EventEmitter<any> = new EventEmitter();

    constructor(private _ElectronService: ElectronService) {}

    public informLanguageUpdate() {
        // todo Currently doesn't work.
    }

    public setOddType_PRE(e, rowNumber: number) {
        this.oddType_PRE[rowNumber] = e;
        this.oddType_PRE_Listener.emit(this.oddType_PRE);
    }

    public setAllOddType_PRE(oddTypes: Array<string>) {
        this.oddType_PRE = oddTypes;
        this.oddType_PRE_Listener.emit(this.oddType_PRE);
    }

    public resetOddType_PRE() {
        this.oddType_PRE = ['RoM', 'OU', 'NG'];
        this.oddType_PRE_Listener.emit(this.oddType_PRE);
    }

    public setOddType_LIVE(e, rowNumber) {
        this.oddType_LIVE[rowNumber] = e;
        this.oddType_LIVE_Listener.emit(this.oddType_LIVE);
    }

    public resetOddType_LIVE() {
        this.oddType_LIVE = ['RoM', 'OU', 'NG'];
        this.oddType_LIVE_Listener.emit(this.oddType_LIVE);
    }

    public setSportType(e) {
        this.sportEnum = e;
        this.sportEnum_Listener.emit(this.sportEnum);
        lg('SPORT TYPE', this.sportEnum.toString());

        this.getSportFixture();
    }

    public setTournamentType(e) {
        this.tournamentType = e;
        this.tournamentType_Listener.emit(e);
        //lg('TOURNAMENT TYPE', this.tournamentType.toString());
    }

    public setUniqueTournament(e) {
        // Puan Durumu için BetradarId geliyor
        this.uniquetournament = e;
        this.uniquetournament_Listener.emit(e);
    }

    public setTypeOfList(e) {
        this.typeOfList = e;
        this.typeOfListListener.emit(this.typeOfList);
        //lg('SPORT TYPE', this.typeOfList.toString());
    }

    public getSportFixture() {
        this.getSportFixtureListener.emit(true);
    }

    public setChangeSportFixture() {
        this.changeSportFixture.emit(true);
    }

    public setScoreBoxView(e) {
        this.scoreBoxView = e;
        this.scoreBoxViewListener.emit(this.scoreBoxView);
        lg('Score Box Activation:', this.scoreBoxView ? 'true' : 'false');
    }

    public setExpandId(e) {
        this.expandId = e;
        this.expandIdListener.emit(this.expandId);
        lg('EXPAND ID');
    }

    public setLiveFilteredData(e) {
        this.liveFilteredData = e;
        this.liveFilteredDataListener.emit(this.liveFilteredData);
        //lg('LIVE FILTERED DATA', this.liveFilteredData);
    }

    public setRefreshApp() {
        this.refreshAppListener.emit(true);
    }

    public setScrollChange(direction) {
        if (this.typeOfList === 'live') {
            this.liveScrollChange.emit(direction);
        } else if (this.typeOfList === 'pre') {
            this.preScrollChange.emit(direction);
        }
    }

    public setDateTodayStatus(set: boolean) {
        this.isDateToday = set;
        this.isDateTodayListener.emit(this.isDateToday);
    }

    /*

state;
0: hidden
1: pass Screen
2: pass oK.

*/
    public setAdminScreen(set: boolean, state: number) {
        this.isAdminScreenVisible = set;
        this.adminScreenState = state;
        this.isAdminScreenVisibleListener.emit(this.isAdminScreenVisible);
    }

    public setStatisticModalParameter(e) {
        this.statisticListener.emit(e);
    }

    public setLiveTrackerModalParameter(e) {
        this.liveTrackerListener.emit(e);
    }

    public AllscreenButtonActive(state) {
        console.log('STATE----', state);
        this.buttonIsActive = state;
        console.log('this.buttonIsActive----', this.buttonIsActive);
    }

    public OpenMoneyReader() {
        _sendChromeMessage({
            command: 'runmoneyreader',
        });
    }

    public CloseMoneyReader() {
        _sendChromeMessage({
            command: 'haltmoneyreader',
        });
    }

    public SetQrCode(e) {
        // console.log('SetQrCode_EMİT',e);
        this.qrCodeListener.emit(e);
    }

    public SetCustomerQrStatus(e) {
        this.customerQrStatus = e;
        this.customerQrStatusListener.emit(e);
    }

    public SendElectronMessage(command, arg) {
        if (this._ElectronService != null)
            if (this._ElectronService.isElectronApp) {
                this._ElectronService.ipcRenderer.send(command, arg);
            }
    }

    public SetCustomerCardStatus(e) {
        this.CustomerCardSatus = e;
        this.customerCardStatusListener.emit(e);
    }

    // HEADER GOAL ANIMATION
    public SetLiveGoalListData(e) {
        this.liveGoalList = e;
        this.liveGoalListListener.emit(e);
    }

    public LivetrackerModalClose(e) {
        this.liveTrackerModalCloseListener.emit(e);
    }

    public SetTerminalConfig(e) {
        this.terminalConfig = e;
        this.terminalConfigListener.emit(e);
        localStorage.setItem('tconfig', JSON.stringify(e));

        // // VorabTicket == 0 => MoneyReader Close
        // if (e.TemporaryBet == false || e.IsBetOn == false) {
        //     this.SendElectronMessage('electronListener', {
        //         type: 'moneyReader_control',
        //         money_reader_status: 'disable',
        //     });
        // } else {
        //     this.SendElectronMessage('electronListener', {
        //         type: 'moneyReader_control',
        //         money_reader_status: 'enable',
        //     });
        // }
    }

    public SetTransactionModal(e) {
        this.transactionModalListener.emit(e);
    }

    public SetSlipDuplicateModal(e) {
        this.slipDuplicateModalListener.emit(e);
    }

    public SetBarcodeCardData(e) {
        this.barcodeCardModalEventListener.emit(e);
    }

    OpenBarcodeCardModal() {
        $('#BarcodeCardModal')
            .modal({
                detachable: false,
            })
            .modal('show');
    }

    CloseBarcodeCardModal() {
        $('#BarcodeCardModal')
            .modal({
                detachable: false,
            })
            .modal('hide');
    }

    //Luhn Algorithm ( Kart Numarası doğru mu ? )
    public async CardNoCheck(value) {
        // Accept only digits, dashes or spaces
        if (/[^0-9-\s]+/.test(value)) return false;

        // The Luhn Algorithm. It's so pretty.
        let nCheck = 0,
            bEven = false;
        value = value.replace(/\D/g, '');

        for (let n = value.length - 1; n >= 0; n--) {
            let cDigit = value.charAt(n),
                nDigit = parseInt(cDigit, 10);

            if (bEven && (nDigit *= 2) > 9) nDigit -= 9;

            nCheck += nDigit;
            bEven = !bEven;
        }
        return nCheck % 10 == 0;
    }

    public setOnlyDeposit(status: boolean): void {
        this.isOnlyDeposit = status;
    }
}
